import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=a53b461e&"
import script from "./Feed.vue?vue&type=script&lang=ts&"
export * from "./Feed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports